import { functions, storage, db, analytics } from '../firestore';
import { userData } from '../stores/userStore.js';
import { productFileId, get__store } from '../stores/mainStore.js';


let dynamicHandler = {};

// function get__store(store) {
//     let $val
//     store.subscribe($ => $val = $)()
//     return $val
// }
/*https://stackoverflow.com/questions/41673499/how-to-upload-multiple-files-to-firebase*/
storage.ref().constructor.prototype.putFiles = function (files) {
    var ref = this;
    return Promise.all(files.map(function (file) {
        return ref.child(file.name).put(file);
    }));
}

export async function runStepperAction(action, model) {
    return await dynamicHandler[action](model);
}

dynamicHandler.getSneakPeekWebsiteInfos = async function (model) {
    return doPost('sneak_peek-getSneakPeekWebsiteInfos', model);
    //return doPost('getWebsiteSneakPeek', model);
}

dynamicHandler.generateWebsite = async function (model) {
    return doPost('sneak_peek-getWebsiteSneakPeek', model);
}

dynamicHandler.generateSocial = async function (model) {

    let files = [];
    if (model.setViaUrl) {
        if (model.design.logo != null && model.design.logo == model.design.customLogo) {
            files.push(model.design.logo);
            model.design.logoNeedsUpload = true;
        }
        else{
            model.design.logo = model.design.logo
            model.design.logoIsExternal = true;

        }
        if (model.design.hero != null && model.design.hero == model.design.customHero) {
            files.push(model.design.hero);
            model.design.heroNeedsUpload = true;
        }
        else{
            model.design.hero = model.design.hero;
            model.design.heroIsExternal = true;

        }
    }
    else {
        model.design.heroNeedsUpload = true;
        model.design.logoNeedsUpload = true;
        if (model.design.logo != null)
            files.push(model.design.logo);
        if (model.design.hero != null)
            files.push(model.design.hero);
    }

    const storageRef = storage.ref(`sneak-peek-users/${get__store(userData).user.uid}`);
    // storageRef.putFiles(files).then((docRefs) => {
    //         model.logo = docRefs[0].metadata.fullPath;
    //         model.hero = docRefs[1].metadata.fullPath;
    //         return doPost('getSocialSneakPeek', model);
    // }).catch((error) => {
    //     console.log('Error uploading files', error)
    // });
    console.log(files)

    model.design.logoPalette = null; //TODO [[300,400,500]] structure can not be saved into firebase
    if (files.length > 0) {
        try {
            const response = await storageRef.putFiles(files).then((docRefs) => {

                //TODO ugly -> refactor
                if (model.design.logo != null &&  model.design.logoNeedsUpload) {
                    model.design.logo = docRefs[0].metadata.fullPath;
                    if (model.design.hero != null && model.design.heroNeedsUpload)
                        model.design.hero = docRefs[1].metadata.fullPath;
                }
                else if (model.design.hero != null && model.design.heroNeedsUpload)
                    model.design.logo = docRefs[0].metadata.fullPath;
                return doPost('sneak_peek-getSocialSneakPeek', model);
            });
            return response.data;
        } catch (e) {
            console.log('Error occurred on auth', e);
            return { Error: e };
        }
    }
    else {
        return doPost('sneak_peek-getSocialSneakPeek', model);
    }
}

// console.log(data)
// var file = data.document.logo;
// if (file != null) {
//     var storageRef = storage.ref(`tenants/${get__store(currentTenant).tid}/${file.name}`);
//     console.log(storageRef);
//     return storageRef.put(file).then(function (snapshot) {
//         console.log('Uploaded a blob or file!');
//         data.document.file = snapshot.metadata.fullPath
//         return doPost('productCreate', data);
//     });
// }
// else {
//     return doPost('productCreate', data);

// }

export async function sneakPeekSubmit(model) {
    try {
        const response = await doPost('sneak_peek-sneakPeekSubmit', model);
        return response.data;
    } catch (e) {
        console.log('Error occurred on auth', e);
        return { Error: e };
    }
}

export async function sendFeedback(feedback) {
    if (feedback == null || feedback == '' || get__store(productFileId) == null)
        return;
    let docRef = db.collection(`sneak-peek-users`).doc(get__store(userData).user.uid).collection('products').doc(get__store(productFileId));
    if (docRef == null)
        return;
    try {
        const response = await docRef.update({
            'user.feedbackBeforeState': feedback
        });
        return { Result: true }
    } catch (e) {
        console.log('Error occurred on updateTexts in user doc', e);
        return { Error: e };
    }
}

export async function updateTexts(model) {

    let dataToChange = {};
    let runUpdate = false;
    for (let key in model) {
        let val = model[key];
        if (val != null && val != '') {
            dataToChange[`texts.${key}`] = val;
            if (key == 'copies' && runUpdate == false) runUpdate = val.length > 0;
            else runUpdate = true;
        }
    }

    if (!runUpdate || get__store(productFileId) == null)
        return;

    let docRef = db.collection(`sneak-peek-users`).doc(get__store(userData).user.uid).collection('products').doc(get__store(productFileId));
    if (docRef == null)
        return //TODO No product Doc found create one?
    try {
        const response = await docRef.update(dataToChange);
        return { Result: true }
    } catch (e) {
        console.log('Error occurred on updateTexts in user doc', e);
        return { Error: e };
    }


}

async function doPost(functionName, data) {
    let func = functions.httpsCallable(functionName);
    return await func({ model: data, info: { tenantId: 'sneak-peek', productId: get__store(productFileId) } });
}

export async function track(event, params) {
    const eventName = `sp:${event}`;
    console.log(`Logged ${eventName}`, params);
    analytics.logEvent(eventName, params);
}

export async function setUserProperties(params) {
    if (params == null)
        return;
    analytics.setUserProperties(params);
}  